<!-- eslint-disable vue/html-self-closing -->
<template>
  <div v-if="objectName">
    <custom-select
      v-model="selectedModel"
      :options="options"
      :clearable="true"
      :filterable="false"
      :label="isUser ? 'fullName' : 'title'"
      :searchable="true"
      @search="searchMembers"
    >
      <user-label-item
        slot-scope="{ option }"
        :user="option"
      />
    </custom-select>
    <input
      :name="objectName"
      type="hidden"
      :value="selectedModel?.id || null"
    />
  </div>
  <div v-else>
    <pacman-loader
      size="15"
      style="position: relative !important"
    />
  </div>
</template>

<script>
import UserLabelItem from '@shared/shared-components/shared/user-label-item';
import PacmanLoader from '@shared/shared-components/shared/packman-loader';
import RefS from '@shared/services/reference.service';
// eslint-disable-next-line import/no-unresolved
import CustomSelect from './custom-select';

export default {
  name: 'ProjectMemberSelector',
  components: { PacmanLoader, UserLabelItem, CustomSelect },
  props: {
    objectName: {
      required: true,
      default: null
    },
    alias: {
      type: String
    },
    projectAlias: {
      type: String
    },
    isProject: {
      type: Boolean,
      default: true
    }
  },

  data() {
    return {
      options: [],
      selectedModel: null,
      isUser: false,

    };
  },
  mounted() {
    if (this.objectName === 'userUuid' || this.objectName === 'userId') {
      this.isUser = true;
    }
  },
  methods: {
    searchMembers(q) {
      if (q) {
        if (this.isProject && this.isUser) {
          setTimeout(() => {
            RefS.getProjectRefUsers(this.alias, this.projectAlias, { q }).then((res) => {
              this.options = res.items;
            });
          }, 500);
        }
        else if(this.isUser) {
          setTimeout(() => {
            RefS.getRefUsers({ q }).then((res) => {
              this.options = res.items;
            });
          }, 500);
        } else {
          setTimeout(() => {
            RefS.getRefTeams({ q }).then((res) => {
              this.options = res.items;
            });
          }, 500);
        }
      }
    }
    // unfocus() {
    //   const inputs = document.querySelectorAll('.vs__search');

    //   inputs.forEach(input => {
    //     input.blur()
    //   })
    // }
  }
};
</script>
